import type { ReactNode } from 'react';
import { CacheProvider } from '@emotion/react';
import type { EmotionCache } from '@emotion/cache';
import { ChakraProvider } from '@chakra-ui/react';
import { Provider as ReduxProvider } from 'react-redux';
import { system } from '@/theme/system';
import type { AppStore } from '@/store';

type AppProvidersProps = {
  children: ReactNode;
  store: AppStore;
  emotionCache?: EmotionCache;
};

export function AppProviders({ children, store, emotionCache }: AppProvidersProps) {
  const tree = (
    <ReduxProvider store={store}>
      <ChakraProvider value={system}>{children}</ChakraProvider>
    </ReduxProvider>
  );

  if (!emotionCache) {
    return tree;
  }

  return <CacheProvider value={emotionCache}>{tree}</CacheProvider>;
}
